export default __webpack_public_path__ + "static/media/discounts.437bf112.svg";